module.exports = __webpack_public_path__ + "img/Metatext_zapier-illustration.193b7a99.jpg";